import React, { FC } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button } from '@mui/material';
import { PreviewButtonProps } from './types';

const PreviewButton: FC<PreviewButtonProps> = ({ handleClick, ...rest }) => {
  return (
    <Button size='small' sx={{ flexShrink: 0 }} startIcon={<VisibilityIcon />} onClick={handleClick} {...rest}>
      Preview
    </Button>
  );
};

export default PreviewButton;
